
import { supabase } from '@/integrations/supabase/client';
import { ProfessionalInterface } from './types';
import { getProfessionalFromData } from './professionalUtils';

/**
 * Gets all professionals - uses public view for anonymous users, full table for authenticated users
 */
export const getProfessionals = async (): Promise<ProfessionalInterface[]> => {
  try {
    console.log('Fetching professionals from public view...');
    // Always use public view to ensure consistent filtering regardless of user permissions
    // Explicit field selection (no phone/email for security)
    const result = await supabase
      .from('professionals_public_view')
      .select(`
        id, user_id, name, profession, city, location, rating, review_count,
        image, about, specialties, sub_specializations, experience_range,
        is_verified, status, created_at, updated_at, languages, company_name,
        tiktok_url, facebook_url, instagram_url, working_hours, experience_years,
        areas, profession_ids, specialization_ids, work_cities, image_url
      `);
    
    const data = result.data;
    const error = result.error;

    if (error) {
      console.error('Error fetching professionals from public view:', error);
      return [];
    }

    console.log(`Fetched ${data?.length || 0} professionals from public view`);
    return data.map(professional => getProfessionalFromData(professional));
  } catch (error) {
    console.error('Error getting professionals:', error);
    return [];
  }
};

// Add alias for compatibility with existing code
export const fetchProfessionals = getProfessionals;
